module.exports = __webpack_public_path__ + "static/media/emotions-gifs.8447cd10.png";